<template>
  <b-container>
    <h1>{{ $t("tracking.nonAttendanceReason.list") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row>
      <router-link :to="getUrlCreate()">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="data">
          <router-link :to="getUrlEdit(data.item)">
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
          <b-button
            v-if="isNonAttendanceReasonActive(data.item)"
            size="sm"
            class="btn-checklist ml-2"
            @click="nonAttendanceReasonDesactive(data.item)"
            >{{ $t("geral.delete") }}</b-button
          >
          <b-button
            v-else
            size="sm"
            class="btn-checklist ml-2"
            @click="nonAttendanceReasonActivate(data.item)"
            >{{ $t("geral.activate") }}</b-button
          >
          <!-- <div>{{getUrlEdit(data.item)}}</div> -->
        </template>
        <template v-slot:cell(ativo)="data">
          {{ data.value ? "Sim" : "Não" }}
        </template>
      </b-table>
    </b-row>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
    
  </b-container>
</template>

<script>
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
export default {
  name: "NonAttendanceReasonList",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    NonAttendanceReasonCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/nonAttendanceReason/NonAttendanceReasonCrudData.vue"
      ),
      TablePaginationProps
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
            key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sequenceNumber",
          filterKey: "sequenceNumber",
          label: this.$t("tracking.nonAttendanceReason.sequenceNumber"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "displayName",
          filterKey: "displayName",
          label: this.$t("tracking.nonAttendanceReason.displayName"),
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          sortable: true,
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      computed: {},
      tableFilters: {
        description: "",
        sequenceNumber: "",
        active: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  methods:{
    getUrlCreate(){
        return `/trackingShippingCompany/nonAttendanceReason/create/`;  
    },
    getUrlEdit(nonAttendanceReason) {
      return `/trackingShippingCompany/nonAttendanceReason/edit/${nonAttendanceReason.id}`;
    },
    isNonAttendanceReasonActive(nonAttendanceReason) {
      if (nonAttendanceReason) {
        return nonAttendanceReason.active
      }
      return true;
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      // console.log(this.getUrlEdit)
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        active: true
      };
      this.$api
        .post("/v1/nonAttendanceReason/list", apiParam)
        .then((response) => {
          const items = response.data.items;
          console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    nonAttendanceReasonActivate(nonAttendanceReason) {
      this.$api
        .get("v1/nonAttendanceReason/activate/"+ nonAttendanceReason.id.toString())
        .then((response) => {
          // console.log("entrou")
          nonAttendanceReason.active = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    nonAttendanceReasonDesactive(nonAttendanceReason) {
      this.$api
        .get("v1/nonAttendanceReason/Deactivate/" + nonAttendanceReason.id.toString())
        .then((response) => {
          // console.log("entrou")
          // nonAttendanceReason.active = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  }
};
</script>